import React, { useState, useEffect, useContext, useCallback, useRef } from "react";
import { Col, Row, Button, Form, Modal } from "react-bootstrap";
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { getCDNImage } from '../globals';
import { T } from "react-translator-component";
import Screen from '../components/Screen';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell, faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { HotelContext } from "../context/hotel";
import { CheckInContext } from "../context/checkin";
import { UserContext } from "../context/user";
import { i18nValue } from '../functions';
import { QrReader } from 'react-qr-reader';
import Reservation from "../components/Reservation";
import { useWebPush } from "../context/webpush";
import LangSelector from "../components/LangSelector";
import { Player } from '@lottiefiles/react-lottie-player';
import { useLanguage } from "../hooks/useLanguage";
import { isDemo, isHostz, isHostzSwissstay, isOffgrid } from "../components/CheckIn/hotelConditions";
import CheckInIdentifySelector from "../components/CheckInIdentifySelector";
import { useKiosk } from "../hooks/useKiosk";
import './CheckInIdentify.css';
import { faLock, faUser, faSignOutAlt } from "@fortawesome/free-solid-svg-icons";

const CheckInIdentify = () => {

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const { data: hotel, getUrlPath, sectionsByCode } = useContext(HotelContext);
  const { identify, identifyByData, data: checkinData } = useContext(CheckInContext);
  const { inStay, language, setLanguageByCode, stayConfirmInit } = useContext(UserContext)
  const { permission, askNotificationPermission } = useWebPush()
  const { isKioskMode, setLogoutKiosk, isKioskLoggedIn, loginKiosk } = useKiosk();
  const [init, setInit] = useState(false);
  const [securityCode, setSecurityCode] = useState('');
  const [loadingScreen, setLoadingScreen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [valid, setValid] = useState(false);
  const [error, setError] = useState(false);

  // Estados para los nuevos campos
  const [lastName, setLastName] = useState('');
  const [roomNumber, setRoomNumber] = useState('');

  const [useQR, setUseQR] = useState(false);
  const [notificationConfirm, setNotificationConfirm] = useState(false);

  const [waitInStayToRedirect, setWaitInStayToRedirect] = useState(null);
  const [waitToRedirect, setWaitToRedirect] = useState(null);

  // Estados para el modal de logout
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [logoutPin, setLogoutPin] = useState('');
  const [logoutError, setLogoutError] = useState('');
  const [logoutLoading, setLogoutLoading] = useState(false);

  const { languageCode } = useLanguage();

  const modalContainerRef = useRef(null);
  const lottieStaticRef = useRef();

  const redirect = searchParams.get('redirect');



  const location = useLocation();

  const doIdentify = useCallback((code, queryParam = null) => {
    setLoading(true)
    setError(false);
    identify(code)
      .then(r => {
        if (!r) {
          setValid(false);
          setError(true);
          setLoading(false);
          return
        }

        if (r.language) {
          const langCode = languageCode(r.language);
          if (langCode) {
            if (hotel.languages?.includes(langCode)) {
              setLanguageByCode(langCode);
            }
          }
        }

        setValid(true)
        setLoading(false)

        if (redirect) {
          stayConfirmInit();
          setWaitToRedirect(getUrlPath(
            redirect.replace(/^\//, "") + '?redirected=true'
          ));
        } else {

          if (r.status === "pending") {
            setInit(true)
          }
          let urlRedirect = location.pathname.replace(getUrlPath(''), '').replace(/__/g, '/');
          urlRedirect = urlRedirect.replace('checkin/identify', '');
          urlRedirect = urlRedirect.replace('/' + code, '');
          if (!queryParam && urlRedirect !== '') {
            stayConfirmInit();
            setWaitToRedirect(getUrlPath(urlRedirect + '?redirected=true'));
            // navigate(getUrlPath(urlRedirect), { replace: true })
          } else {
            if (r.status !== "pending") {
              navigate(getUrlPath('checkin'), { replace: true })
            }
          }

        }

        // if (r.inStay && r.status === "in_stay") {
        //   if (redirect) {
        //     navigate(getUrlPath(redirect), { replace: true })
        //   }

        //   if (!redirect || (!redirect.startsWith("requests/") && !redirect.startsWith("reviews/"))) {
        //     setTimeout(() => {
        //       // navigate(getUrlPath('services'), { replace: true })
        //       navigate(getUrlPath('status'), { replace: true })
        //     }, 2000)
        //   }

        // } else {
        //   setValid(true)
        //   setLoading(false)

        //   if (redirect && (redirect.startsWith("requests/") || redirect.startsWith("reviews/") || redirect.startsWith("checkin/"))) {
        //     navigate(getUrlPath(redirect), { replace: true })
        //   } else {
        //     if (r.status === "pending") {
        //       setInit(true)
        //     } else {
        //       navigate(getUrlPath('checkin'), { replace: true })
        //     }
        //   }
        //   // if (r.status === "pending") {
        //   //   setInit(true)
        //   // } else {
        //   //   if (redirect && (redirect.startsWith("requests/") || redirect.startsWith("reviews/"))) {
        //   //     navigate(getUrlPath(redirect), { replace: true })
        //   //   } else {
        //   //     navigate(getUrlPath('checkin'), { replace: true })
        //   //   }
        //   // }
        // }




      })
      .catch(err => {
        console.error(err.message)
        setValid(false);
        setError(true);
        setLoading(false);
      })
  }, [hotel.code])

  
  const doIdentifyByData = useCallback(data => {
    setLoading(true)
    setError(false);
    console.log('12ene ckeckIn data', data);
    identifyByData(data)
      .then(r => {
        if (!r) {
          setValid(false);
          setError(true);
          setLoading(false);
          return
        }

        if(r?.error){
          setValid(false);
          setError(r);
          setLoading(false);
          return;
        }

        console.log('11dic ckeckIn data', r);
        if (r.language) {
          const langCode = languageCode(r.language);
          if (langCode) {
            if (hotel.languages?.includes(langCode)) {
              console.log('11dic seteo lang', langCode);
              setLanguageByCode(langCode);
            }
          }
        }

        // Si ya se completó el proceso anteriormente, se redirige a la pantalla de bienvenida del Kiosk
        if( isKioskMode && r?.webCheckInDone && r?.status !== 'pending' && r?.status !== 'done'){
          setValid(true);
          setLoading(false);
          navigate(`/${hotel.code}/kiosk/welcome-kiosk`, { replace: true });
          return;
        }

        setValid(true)
        setLoading(false)
        if (redirect) {
          stayConfirmInit();
          setWaitToRedirect(getUrlPath(
            redirect.replace(/^\//, "") + '?redirected=true'
          ));
        } else {
          if (r.status === "pending") {
            setInit(true)
          }

          let urlRedirect = location.pathname.replace(getUrlPath(''), '').replace(/__/g, '/');
          urlRedirect = urlRedirect.replace('checkin/identify', '');
          if (urlRedirect != '') {
            stayConfirmInit();
            setWaitToRedirect(getUrlPath(urlRedirect + '?redirected=true'));
            // navigate(getUrlPath(urlRedirect), { replace: true })
          } else {
            // Si es Kiosk y el estado es pending, observed o no se hizo el webcheckin, se redirige a la pantalla de edit-new
            if(isKioskMode && ((r?.status === 'pending' || r?.status === 'observed') || !r?.webCheckInDone)){
              navigate( `/${hotel.code}/checkin/edit-new`, { replace: true });
              return;
            }else{
              navigate(getUrlPath('checkin'), { replace: true })
            }
          }

        }

      })
      .catch(err => {
        console.error(err.message)
        setValid(false);
        setError(err);
        setLoading(false);
      })
  }, [loading])

  useEffect(() => {

    let _pathname = location.pathname;
    if (_pathname[_pathname.length - 1] == '/') {
      _pathname = _pathname.slice(0, -1);
    }
    let _pathname_arr = _pathname.split('/');
    let _queryParam = _pathname_arr[_pathname_arr.length - 1];
    if (_queryParam === 'identify') {
      _queryParam = null;
    }
    let _securityCode = false;
    // Return path legacy (services__service_room_service): no es código de reserva
    if (_queryParam && _queryParam.includes('__')) {
      setInit(true);
      return;
    }
    if (_queryParam && _queryParam.startsWith('e_')) {
      _securityCode = _queryParam.replace('e_', '');
    } else if (_queryParam && _queryParam.indexOf('_') !== -1) {
      const _parseData = _queryParam.split('_');
      _queryParam = _parseData[0];
      _securityCode = _parseData[1];
    } else {
      _securityCode = _queryParam;
    }

    if (_securityCode) {
      doIdentify(_securityCode, _queryParam)
    } else {
      setInit(true);
    }


  }, [])

  const handleContinue = useCallback(() => {
    // if (permission === 'default' && (!isHostz(hotel?.id))) {
    //   setNotificationConfirm(true);
    // } else {
    //   goNext();
    // }
    //TODO_G: 2025-07-22: Quitamos pedido de notificaciones
    goNext();
  }, [permission, hotel]);

  useEffect(() => {

    if (waitInStayToRedirect && inStay) {
      navigate(waitInStayToRedirect, { replace: true })
    }
    if (waitToRedirect) {
      navigate(waitToRedirect, { replace: true })
    }

  }, [inStay, waitInStayToRedirect, waitToRedirect]);

  const goNext = () => {
    setLoadingScreen(true);
    setTimeout(() => {
      navigate(getUrlPath("/checkin/edit"), { replace: true })
    }, [100]);
  }

  const handleLogoutClick = () => {
    setShowLogoutModal(true);
    setLogoutPin('');
    setLogoutError('');
  };

  const handleLogoutSubmit = async () => {
    if (!logoutPin.trim()) {
      setLogoutError(T('kiosk.login.error_empty'));
      return;
    }

    setLogoutLoading(true);
    setLogoutError('');
    
    try {
      // Verificar el PIN llamando a la misma API del backend
     const response = await loginKiosk(logoutPin);

      if (response?.valid === true) {
        // PIN es correcto, hacer logout
        setLogoutKiosk();
        setShowLogoutModal(false);
        // Redirigir a login
        navigate(`/${hotel.code}/kiosk/login`, { replace: true });
      } else {
        setLogoutError(T('kiosk.login.error_invalid'));
        setLogoutPin('');
      }
    } catch (err) {
      console.error('Error verifying PIN:', err);
      setLogoutError(T('kiosk.login.error_process'));
      setLogoutPin('');
    } finally {
      setLogoutLoading(false);
    }
  };

  const handleLogoutKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleLogoutSubmit();
    }
  };

  if (!init) {
    return (<div className="vico-identify-container">
      {hotel.logo && <div style={{ padding: 20, textAlign: "center" }}>
        <img className="checkin-image" src={getCDNImage(hotel.logo)} style={{ width: 140, height: 140, objectFit: "contain", background: "#FFF", borderRadius: "50%", border: "1px solid #DDD", padding: 8 }} />
        <div>
          <h6 className="mb-0 mt-3" style={{ fontWeight: "bolder", fontSize: 18 }}>{hotel.name}</h6>
          <p className="mb-0" style={{ fontSize: 14, color: "#888" }}>{hotel.address}</p>
        </div>
      </div>}
      <Player
        // ref={this.player} // set the ref to your class instance
        autoplay={true}
        loop={true}
        src="/lottie/identify.json"
        style={{ height: '300px', width: '400px' }}
      ></Player>
      <div className="text-center mt-3 mx-5">
        {/* <div className="spinner-border" role="status"></div> */}
        <h5 style={{ fontWeight: "bold" }}>Searching for reservation...</h5>
        <p style={{ fontSize: 15, color: "#888" }}>This process may take a few seconds, thank you for your patience!</p>
      </div>
    </div>)
  }

  const handleSecurityCode = (event) => {
    const value = event.target.value
    const sanitizedCode = value.replace(/\s/g, "")
    setSecurityCode(sanitizedCode)
  }

  return (
    <>
      {isKioskMode && (
        <>
          <div className="kiosk-identify-background"></div>
          <div className="kiosk-identify-container">
            {/* Botón de Logout */}
            {isKioskLoggedIn && (
              <button 
                onClick={handleLogoutClick}
                className="kiosk-logout-btn"
                title={T('kiosk.logout.title')}
              >
                <FontAwesomeIcon icon={faSignOutAlt} />
              </button>
            )}
            <div className="kiosk-identify-content">
              {/* Form Wrapper */}
              <div className="kiosk-identify-form-wrapper">
              <div className="kiosk-login-branding">
                {hotel?.logo && (
                    <img 
                        src={getCDNImage(hotel.logo)} 
                        alt={hotel?.name || 'Hotel Logo'} 
                        className="kiosk-login-logo"
                    />
                )}
                <div className="kiosk-login-hotel-info">
                    <h1 className="kiosk-login-hotel-name">{hotel?.name || 'Hotel'}</h1>
                </div>
                </div>

              {/* Language Selector */}
              <div>
                <LangSelector />
              </div>
                <div className="kiosk-identify-separator"></div>
                <div className="kiosk-login-icon-wrapper-container">
                    <div className="kiosk-login-icon-wrapper">
                        <FontAwesomeIcon icon={faUser} className="kiosk-login-icon" />
                    </div>
                    <h2 className="kiosk-login-title">{T('kiosk.checkin')}</h2>
                </div>
             
                {!loadingScreen && !valid && (
                  <>
                    <CheckInIdentifySelector
                      hotel={hotel}
                      loading={loading}
                      error={error}
                      setError={setError}
                      onSubmit={f => {
                        if(isKioskMode && f.code && f.lastName) {
                          doIdentifyByData({
                            code: f.code,
                            lastName: f.lastName,
                            source: 'kiosk'
                          })
                        }
                      }}
                    />

                    {error && (
                      <div className="kiosk-identify-error">
                        {error.message ? T(error.message) : T('checkin.identify-error')}
                      </div>
                    )}
                  </>
                )}

                {loadingScreen && (
                  <div className="loading text-center">
                    <div className="spinner-border" role="status"></div>
                  </div>
                )}
              </div>
              {/* Footer */}
              {/* <div className="kiosk-identify-footer">
                <p>{hotel?.name}</p>
              </div> */}
            </div>
          </div>

      {/* Modal de Logout */}
      {isKioskMode && showLogoutModal && (
        <Modal
          show={showLogoutModal}
          onHide={() => setShowLogoutModal(false)}
          backdrop="static"
          keyboard={false}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title></Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="text-center">
              <FontAwesomeIcon icon={faLock} style={{ fontSize: 40, color: '#FF6B6B', marginBottom: 20 }} />
              <p className="mt-3 mb-3">{T('kiosk.logout.confirm')}</p>
              <Form.Control
                type="password"
                value={logoutPin}
                onChange={(e) => {
                  setLogoutPin(e.target.value.replace(/\D/g, ''));
                  setLogoutError('');
                }}
                onKeyPress={handleLogoutKeyPress}
                disabled={logoutLoading}
                className="text-center"
                maxLength="6"
                style={{ fontSize: 20, letterSpacing: '5px' }}
              />
              {logoutError && (
                <div className="alert alert-danger mt-3 mb-0">
                  {logoutError}
                </div>
              )}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button 
              variant="secondary" 
              onClick={() => setShowLogoutModal(false)}
              disabled={logoutLoading}
            >
              {T('general.cancel')}
            </Button>
            <Button 
              variant="danger" 
              onClick={handleLogoutSubmit}
              disabled={logoutLoading || logoutPin.length === 0}
            >
              {logoutLoading ? (
                <>
                  <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                  {T('general.accept')}
                </>
              ) : (
                T('general.accept')
              )}
            </Button>
          </Modal.Footer>
        </Modal>
      )}
        </>
      )}

      {!isKioskMode && (
        <Screen
          section="identify"
          hideHeader={isKioskMode}
          title={T("complete-to-web-checkin")}
        >
          <div className="container-modal" ref={modalContainerRef}></div>
          {!loadingScreen && valid && <div className="text-center mt-5" style={{ background: "white", border: "1px solid #EEE", borderRadius: 10, padding: "10px 20px" }}>
        <OnBoardingHeader hotelId={hotel?.id} checkIn={checkinData} logo={hotel.logo} />
        <LangSelector />
        <Reservation
          checkIn={checkinData}
          border={false}
          showPrice={false}
          showRowInfo={!isHostzSwissstay(hotel.id)}
          className="mt-3" />
      </div>}
      {!loadingScreen && !valid && <Row className="text-center mt-4">
        <Col>
          {!useQR && false && <>
            {/* <p>{T("general.key_explanation")}</p> */}
            <p className="page-detail-description" dangerouslySetInnerHTML={{ __html: i18nValue(sectionsByCode.identify, 'desc', language) }} ></p>
            <Form.Control
              type={'text'}
              maxLength={45}
              value={securityCode}
              disabled={loading}
              style={{ fontSize: 24 }}
              onChange={handleSecurityCode}
              className={'text-center mt-3 mb-3'}
            />
            <Button
              size={'lg'}
              variant={'primary'}
              type={'button'}
              block={true}
              disabled={securityCode === null || securityCode.length < 4}
              onClick={() => doIdentify(securityCode)}
            >
              {T('Validate Code')}
            </Button>

            {error && <p className="text-danger mt-4">{T('checkin.identify-error')}</p>}

            <Button
              size={'lg'}
              variant={'secondary'}
              type={'button'}
              block={true}
              onClick={() => doIdentifyByData({ lastName, roomNumber })}
            >
              {T('checkin.identificate')}
            </Button>
          </>}

          <Player
            ref={lottieStaticRef}
            autoplay={false}
            loop={false}
            src="/lottie/identify.json"
            style={{ height: '300px', width: '300px' }}
            onEvent={(e, i) => {
              if (e === 'load') {
                lottieStaticRef.current.setSeeker(65, false);
              }
            }}
          ></Player>
          <CheckInIdentifySelector
            hotel={hotel}
            loading={loading}
            error={error}
            setError={setError}
            onSubmit={f => {
              if(isKioskMode && f.code && f.lastName) {
                doIdentifyByData({
                  code: f.code,
                  lastName: f.lastName
                })
              }else{
                if (f.code) {
                  doIdentify(f.code)
                } else {
                  doIdentifyByData({
                    lastName: f.lastName,
                    roomNumber: f.room
                  })
                }
              }
             
            }}
          />

          {useQR && <QrReader
            constraints={{ facingMode: 'environment' }}
            onResult={(result, error) => {
              if (!!result) {
                if (result?.text?.indexOf('checkin/identify/') !== false) {
                  const _arr = result.text.split('_');
                  setSecurityCode(_arr[_arr.length - 1]);
                  doIdentify(_arr[_arr.length - 1])
                }
              }

              // if (!!error) {
              //   console.info(error);
              // }
            }}
            style={{ width: '100%' }}
          />}
        </Col>
      </Row>}
      {false && !loadingScreen && !valid && <div className="footer-container">
        <Button
          size={'lg'}
          variant="secondary"
          type={'button'}
          block={true}
          style={{ borderColor: '#CCC', borderStyle: "solid", backgroundColor: "#FFF", borderWidth: 2, color: "#888" }}
          onClick={() => setUseQR(!useQR)}
        >
          {!useQR ? T('general.identify-using-qr') : T('general.identify-using-code')}
        </Button>
      </div>}
      {!loadingScreen && valid && <div className="footer-container">
        <Button
          size={'lg'}
          variant={'success'}
          type={'button'}
          block={true}
          onClick={handleContinue}
        >
          {T('general.start.checkin')}
        </Button>
      </div>}

      {loadingScreen && <div className="loading text-center mt-5"><div className="spinner-border" role="status"></div></div>}

      {notificationConfirm && <Modal
        container={modalContainerRef}
        show={true}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Body>
          <p className="mb-0 general-text-sm text-center">
            <span className="d-block"><FontAwesomeIcon icon={faBell} style={{ fontSize: 50, color: '#3699ff' }} className="mb-2" /></span>
            {T('notifications.confirm-continue')}
          </p>
        </Modal.Body>

        <Modal.Footer className="pl-1 pr-1 text-center d-block">
          <Button size={'md'} type={'button'} variant="secondary" style={{ backgroundColor: "#888" }} onClick={() => goNext()}>{T('general.continue')}</Button>
          <Button size={'md'} type={'button'} variant="secondary" style={{ backgroundColor: "#555" }} onClick={() => askNotificationPermission(result => goNext())}>{T('notifications.enable')}</Button>
        </Modal.Footer>
      </Modal>}
        </Screen>
      )}
    </>
  );
}


const OnBoardingHeader = ({ hotelId, checkIn, logo }) => {

  const guestFullname = [checkIn.reservation?.primaryGuest?.title, (checkIn.passengers?.[0]?.name || checkIn.reservation?.primaryGuest?.firstName), (checkIn.passengers?.[0]?.surname || checkIn.reservation?.primaryGuest?.lastName)].join(" ");

  return (
    <div className='onboarding' style={{ position: 'relative', top: -50, marginBottom: "-30px" }}>
      <div
        className="onboarding-logo position-relative border border-black"
        style={{
          width: 120,
          height: 120,
          borderRadius: '50%',
          left: 'calc(50% - 60px)',
          backgroundImage: logo ? `url(${getCDNImage(logo)})` : 'none',
          backgroundPosition: 'center',
          backgroundSize: '70%',
          backgroundRepeat: 'no-repeat',
          zIndex: 1,
          overflow: 'visible',
          backgroundColor: 'white',
        }}
      >
      </div>
      <div
        className="p-4 text-white welcome-card"
        style={{
          borderRadius: 10,
          background: '#988460',
          boxShadow:
            '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)',
          marginTop: -25
        }}
      >
        <h5 className="mt-2" style={{ fontSize: "1.1rem" }}>{`${T('general.identify-welcome')}, ${guestFullname}`}</h5>
        <div style={{ fontSize: "0.85rem", opacity: 0.7 }}>{isOffgrid(hotelId) ? T('general.identify-welcome-phrase-offgrid') : T('general.identify-welcome-phrase')}</div>
      </div>
    </div>
  );
};

export default CheckInIdentify;